import { setAppState, setAppError } from "../../actions/App/dispatchers";
import { reset_right_rail } from "../../reducers/RightRail/reducer";
import {
    fetch_page_content,
    reset_app_state,
} from "../../actions/Page/asyncDispatchers";
import { reset_page } from "../../reducers/Page/reducer";
import {
    getIsNinePreview,
    metaFlexiblePathReplacer,
    metaNinePreviewReplacer,
} from "../../utils/page/library";

export const fetchFlexibleLandingPageData = (path) => (dispatch) => {
    const isFlpPreview = path.indexOf("/meta/flexible") === 0;
    const isNinePreview = getIsNinePreview(path);

    let effectivePath;
    if (isFlpPreview) {
        effectivePath = metaFlexiblePathReplacer(path);
    } else if (isNinePreview) {
        effectivePath = metaNinePreviewReplacer(path);
    } else {
        effectivePath = path === "/" ? "homepage" : path;
    }

    const baseNavSection =
        path.indexOf("/player/") === 0 ? path.split("/")[2] : "";

    dispatch(reset_app_state(effectivePath));
    dispatch(reset_right_rail());
    dispatch(reset_page());

    return dispatch(fetch_page_content(effectivePath, isNinePreview))
        .then(() => {
            dispatch(setAppState(effectivePath, false, "", baseNavSection));
        })
        .catch((error) => {
            dispatch(setAppError(effectivePath, error.code));
        });
};
